import { faqItems } from "@/mocks/articles";

export default function FAQSection() {
  return (
    <section id="faq" className="relative overflow-hidden bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-[60%] py-10 md:py-14 pr-0 lg:pr-16">
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-12">
              FAQ – Najczęstsze<br />Pytania
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-10">
              {faqItems.map((item, idx) => (
                <div key={idx}>
                  <div className="flex items-start gap-3 mb-3">
                    <span className="text-2xl font-extrabold text-accent-500 leading-none whitespace-nowrap">
                      {(idx + 1).toString().padStart(2, "0")}
                    </span>
                    <h4 className="font-heading font-semibold text-base text-foreground-950 leading-snug">
                      {item.question}
                    </h4>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed ml-9">
                    {item.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[40%] relative min-h-[200px] lg:min-h-0">
            <div className="absolute inset-0 bg-gradient-to-br from-accent-50 via-accent-100/60 to-accent-200/40"></div>
            <div className="absolute inset-0 opacity-40">
              <div className="absolute top-12 left-6 w-24 h-24 rounded-full bg-accent-200/60"></div>
              <div className="absolute bottom-8 right-10 w-32 h-32 rounded-full bg-accent-300/50"></div>
              <div className="absolute top-1/3 right-1/3 w-20 h-20 rounded-full bg-accent-100/70"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}